<div class="a-message-box {{ modifier && 'a-message-box--' + modifier || modifier }}" data-t-name="MessageBox" [innerHTML]="message">
	
</div>